/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getEnvInfo: ()=>getEnvInfo
});
async function getEnvInfo(browser) {
    let osName = 'Unknown';
    let browserName = 'Unknown';
    try {
        const client = await browser.target().createCDPSession();
        const systemInfo = await client.send('SystemInfo.getInfo');
        const browserVersion = await browser.version();
        await client.detach();
        if (systemInfo.modelName) {
            const modelName = systemInfo.modelName.toLowerCase();
            if (modelName.includes('win') || modelName.includes('surface')) osName = 'Windows';
            else if (modelName.includes('mac') || modelName.includes('darwin')) osName = 'macOS';
            else if (modelName.includes('linux')) osName = 'Linux';
        }
        const versionStr = browserVersion.toLowerCase();
        if (versionStr.includes('chrome')) browserName = 'Chrome';
        else if (versionStr.includes('edge') || versionStr.includes('edg')) browserName = 'Edge';
        else if (versionStr.includes('firefox')) browserName = 'Firefox';
        if ('Unknown' !== osName && 'Unknown' !== browserName) return {
            osName,
            browserName
        };
    } catch (error) {
        console.warn('Failed to get environment info via CDP, falling back to userAgent');
    }
    const userAgent = (await browser.userAgent()).toLowerCase();
    if ('Unknown' === osName) {
        if (userAgent.includes('windows') || userAgent.includes('win32') || userAgent.includes('win64')) osName = 'Windows';
        else if (userAgent.includes('mac os x') || userAgent.includes('macos')) osName = 'macOS';
        else if (userAgent.includes('linux') && !userAgent.includes('android')) osName = 'Linux';
    }
    if ('Unknown' === browserName) {
        if (userAgent.includes('edg/') || userAgent.includes('edge/')) browserName = 'Edge';
        else if (userAgent.includes('chrome/') && !userAgent.includes('edg')) browserName = 'Chrome';
        else if (userAgent.includes('firefox/')) browserName = 'Firefox';
    }
    return {
        osName,
        browserName
    };
}
exports.getEnvInfo = __webpack_exports__.getEnvInfo;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getEnvInfo"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});

//# sourceMappingURL=env.js.map